const nav = [
  { path: '/home', text: 'Questionnaire', 'icon': 'clipboard-list' }
];

export default nav;